import React from 'react'

import Webpage from './components/Webpage';

export const App = () => {
  return (
    <div>
      <Webpage />
    </div>
  )
}

export default App;